import inView from 'in-view';

export default function mediaText() {
  // inView(".wp-block-media-text__media__image img").on("enter", function(el) {
  //   $(el).addClass("zoom-out");
  // });
}
